import { webApi } from '@mi-front/api-clients';
import { QueriesView } from '@mi-front/ui';
import { useParams } from 'react-router-dom';

import { ComposeSocialExportUploadPageContent } from './ComposeSocialExportUploadPageContent';
import { ComposeSocialExportUploadPageSkeleton } from './ComposeSocialExportUploadPageSkeleton';

/**
 * Composition social export upload wizard: loads composition + edits, then delegates to content.
 */
export function ComposeSocialExportUploadPage() {
  const { compositionId } = useParams<{ compositionId: string; platform: string }>();

  const compositionQuery = webApi.useGetCompositionsDetailById(compositionId!, {
    query: { enabled: !!compositionId },
  });

  const editsListQuery = webApi.useGetCompositionsDetailEdits(compositionId!, {
    query: { enabled: !!compositionId },
  });

  return (
    <QueriesView
      loader={<ComposeSocialExportUploadPageSkeleton />}
      queries={[compositionQuery, editsListQuery] as never}
    >
      {(raw) => {
        const [composition, edits] = raw as [
          webApi.EnrichedCompositionDetailDto,
          webApi.EnrichedVideoEditorEditListItemDto[],
        ];
        return <ComposeSocialExportUploadPageContent composition={composition} edits={edits} />;
      }}
    </QueriesView>
  );
}
